import { GetterTree } from 'vuex'
import { RootState } from '../../types'
import { ServiceState } from './types'
import Service from '@/calendesk/models/DTO/Response/Service'
import Category from '@/calendesk/models/DTO/Response/Category'

export const getters: GetterTree<ServiceState, RootState> = {
  getServices (state): Service[] | null {
    return state.services
  },
  getCategoryAndServices (state): Category[] | null {
    return state.categoryAndServices
  }
}
